// 행동 챌린지 훅 (시그니처 6엔진 Step 6 "물타기 없는 7일")
// design doc: docs/specs/2026-06-21-step6-challenge-season-design.md §6
// 홈 히어로·MY 도구함이 사용. GET /api/mobile/challenge → get_my_challenge.
//   result=null = 미참가(첫 챌린지 안내), status=active = 진행 게이지(day_index/7).

export interface MyChallenge {
  id: string;
  track: string;
  status: "active" | "success" | "failed";
  started_at: string;
  window_ends_at: string;
  day_index: number;   // 0~7 (게이지 N/7)
  total_days: number;  // 7
  failed_at: string | null;
  success_at: string | null;
  progress_count: number;
  required_count: number;
  judged_at: string | null;
}

export interface LeaderRow {
  user_id: string;
  nickname: string | null;
  avatar_url: string | null;
  signature_badge: string | null;
  success_count: number;
}

export interface ChallengeEligibility {
  track: string;
  eligible_count: number;
  can_join: boolean;
  reason: "ok" | "track_closed" | "no_eligible_trade" | "already_active" | "invalid_track";
}

export const DEFAULT_TRACK = "review_existing_1_7d";

// 트랙 메타 (과거 기록용 구 트랙 포함)
// 아이콘은 유니코드 이모지가 아니라 **CSIcon 이름**을 담는다(2026-08-19 전환).
// 종전 "🚫"는 ①OS별 모양이 달라지고 ②빨간 원색이라 §G-1 색 3계열 밖이며
// --cs-rise(상승 빨강)와 겹쳐 오독을 만들고 ③"금지" 기호가 긍정적 도전 앞에 붙어
// 참여 유도가 아니라 경고로 읽혔다. shield = "유혹을 막아내는 7일" 은유.
// 정본: docs/specs/2026-07-08-emoji-to-character-ip-design.md §T1(사물·기호는 라인아이콘)
export const CHALLENGE_TRACKS: Record<string, { icon: string; title: string; desc: string }> = {
  review_existing_1_7d: {
    icon: "target",
    title: "지난 거래 복기 1건",
    desc: "7일 안에 지난 손실 매도 한 건을 돌아봐요",
  },
  no_averaging_down_7d: {
    icon: "shield",
    title: "누적 평단 아래 매수 쉬기 · 7일",
    desc: "같은 종목을 이전 매수 누적 평균보다 낮게 사면 종료돼요",
  },
};
